import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { environment } from '@app/environment';
import { AuthService } from '@app/services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {
    
    constructor (
        private router: Router,
        private authService : AuthService
    ) {}
    
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
            return this.checkTokenLogin();
    }
    
    canLoad(
        route: Route,
        segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {  
            return this.checkTokenLogin();
    }
    
    async checkTokenLogin() {        
        let loggedUser = await this.authService.checkTokenUser();
        if(loggedUser !== null){
            /* verification accès route */
            return true;
        }
        else{            
            return false;
        }  
    }
}
